import { render } from "./AdreseLivrare.vue?vue&type=template&id=cda2c646&scoped=true&ts=true"
import script from "./AdreseLivrare.ts?vue&type=script&lang=ts"
export * from "./AdreseLivrare.ts?vue&type=script&lang=ts"

import "./AdreseLivrare.vue?vue&type=style&index=0&id=cda2c646&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda2c646"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QDialog,QCard,QBar,QTooltip,QSpace,QCardSection});qInstall(script, 'directives', {ClosePopup});
